import React, { useEffect, useState } from "react";
import ConfirmationDlg from "../ConfirmationDlg";
import { DynamicProblemTypeForm } from "./form";
import NormalInput from "../form/HorizontalNormalInput";
import { location } from "../../api";
import { generateParentLocationId } from "../../utils/helper";

export const LocationFilter = ({
  selectedId = null,
  onChange,
  type = "button",
  defaultValue = null,
  defaultOptionsValue = [],
  emptyField = [],
}) => {
  const [selectedProblemType, setSelectedProblemType] = useState(null);
  const [selectedProblemTypePrev, setSelectedProblemTypePrev] = useState([]);
  const [selectedTempProblemType, setSelectedTempProblemType] = useState(null);
  const [selectedTempProblemTypePrev, setSelectedTempProblemTypePrev] =
    useState([]);

  const [open, setOpen] = useState();
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (selectedId) {
      getLocation(selectedId);
    }
  }, [selectedId]);

  const getLocation = async (id) => {
    const res = await location.get(id);
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setSelectedProblemType(data);
      setSelectedProblemTypePrev(generateParentLocationId(data));
    }
  };

  const handleSelect = () => {
    if (!selectedTempProblemType) {
      onChange(null);
      setSelectedProblemType(null);
      setSelectedProblemTypePrev([]);
    } else {
      onChange(selectedTempProblemType);
      setSelectedProblemType(selectedTempProblemType);
      setSelectedProblemTypePrev(selectedTempProblemTypePrev);
    }
    setOpen(false);
  };

  const handleChangeProblemType = (problemType, selectedProblemTypePrev) => {
    setSelectedTempProblemType(problemType);
    setSelectedTempProblemTypePrev(selectedProblemTypePrev);
  };

  return (
    <>
      {type === "button" && (
        <button
          onClick={() => {
            setOpen(true);
          }}
          className="btn btn-outline-theme w-100"
        >
          {!selectedProblemType && "- Filter Location - (All)"}
          {selectedProblemType
            ? selectedProblemType.location_name
            : defaultValue
            ? defaultValue.location_name
            : ""}
        </button>
      )}
      {type === "input" && (
        <NormalInput
          required
          onClick={() => {
            setOpen(true);
          }}
          type="text"
          value={
            selectedProblemType
              ? selectedProblemType.location_name
              : defaultValue
              ? defaultValue.location_name
              : ""
          }
          name="location_id"
          label="Location Detail"
          emptyField={emptyField}
          placeholder="Select Location"
          style={{
            cursor: "pointer",
            caretColor: "transparent",
          }}
        />
      )}

      <ConfirmationDlg
        title={"Select Location"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSelect}
        btnSubmitText={"Confirm"}
        btnCancelText={"Cancel"}
      >
        <DynamicProblemTypeForm
          onChange={handleChangeProblemType}
          selectedProblemTypePrev={
            selectedProblemTypePrev.length > 0
              ? selectedProblemTypePrev
              : defaultOptionsValue
          }
        />
      </ConfirmationDlg>
    </>
  );
};
